module.exports = "<div *ngIf=\"visible\" [ngSwitch]=\"flashState.name\">\n  <flash-update-email *ngSwitchCase=\"'update-email'\"></flash-update-email>\n  <flash-update-profile *ngSwitchCase=\"'update-profile'\"></flash-update-profile>\n  <flash-error *ngSwitchCase=\"'error'\"></flash-error>\n  <flash-info *ngSwitchCase=\"'info'\"></flash-info>\n  <flash-update *ngSwitchCase=\"'update'\"></flash-update>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/flash/flash.component.html
// module id = 1190
// module chunks = 0